export default __webpack_public_path__ + "static/media/arrow-down.d153af18.svg";